import { RotOptions, RutOptions, WpOptions } from '../types';
import { getApiUrl } from './enviroment';
import { FelixOrder } from './felixApi';

const base = `${getApiUrl()}/wp-json/headless`;

export async function fetchWithType<T>(request: RequestInfo, options?: RequestInit): Promise<T> {
  const response = await fetch(request, options);
  const body = await response.json();
  return body;
}

const getTaxonomy = async (endpoint: string) => {
  if (!endpoint) {
    return;
  }
  const type = endpoint.split('/')[0];
  const slug = endpoint.split('/')[1];
  try {
    const res = await fetch(`${base}/${type}/${slug}`);
    return await res.json();
  } catch (error) {
    console.log(error);
  }
};

const getCustomer = async (slug: string) => {
  try {
    const res = await fetch(`${base}/customer/${slug}`);
    return await res.json();
  } catch (error) {
    console.log(error);
  }
};

const loginCustomer = async ({ id, password }: { id: number; password: string }) => {
  try {
    const res = await fetch(`${base}/customer/login`, {
      method: 'POST',
      body: JSON.stringify({ id, password }),
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return res.status;
  } catch (error) {
    console.log(error);
  }
};

const getOptions = async () => {
  try {
    const res = await fetch(`${base}/webcoptions`);
    return (await res.json()) as WpOptions;
  } catch (error) {
    console.log(error);
  }
};

const getRut = async () => {
  try {
    const data = await fetchWithType<RutOptions>(`${base}/rut`);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const getRot = async () => {
  try {
    const res = await fetch(`${base}/rot`);
    return (await res.json()) as RotOptions;
  } catch (error) {
    console.log(error);
  }
};

const getGreenDiscount = async () => {
  try {
    const res = await fetch(`${base}/green-discount`);
    return await res.json();
  } catch (error) {
    console.log(error);
  }
};

const postOrder = async (data: FelixOrder) => {
  try {
    const res = await fetch(`${base}/weborder`, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return (await res.json()) as { message: string; post_id: number; data: FelixOrder; status?: number };
  } catch (error) {
    console.log(error);
  }
};

export { getCustomer, getGreenDiscount, getOptions, getRot, getRut, getTaxonomy, loginCustomer, postOrder };
